import {
    Percent,
    SubTitle,
    TitleBold,
    UnclaimedTitle,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/Card/Card.styled";
import type { IPackage } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import { i18nFilter } from "app/filters/i18nFilter";

interface IUnclaimedCardProps {
    cardItem: IPackage;
    saveUpToText: string;
}

const UnclaimedCard = ({ cardItem, saveUpToText }: IUnclaimedCardProps) => {
    const i18n = i18nFilter();
    const { ReferralsNumber, DiscountPercentage } = cardItem;

    return (
        <>
            <UnclaimedTitle>
                {i18n("rewards_modal.main_screen.rewards_section.unclaimed_card.title.prefix")}
                <TitleBold>{ReferralsNumber}</TitleBold>
                {i18n("rewards_modal.main_screen.rewards_section.unclaimed_card.title.suffix")}
            </UnclaimedTitle>
            <SubTitle>{i18n("rewards_modal.main_screen.rewards_section.unclaimed_card.subtitle")}</SubTitle>
            <Percent>{DiscountPercentage}%</Percent>
            <SubTitle>{saveUpToText}</SubTitle>
        </>
    );
};

export default UnclaimedCard;
